<div class="p-2">
    <div class="modal-header justify-content-between align-items-center">
    <h4 class="modal-title">{{ isEditMode ? 'Update device' : 'Create new device' }}</h4>
    <button
        type="button"
        class="accello-icon-btn cdm-close-btn"
        (mousedown)="isActive = true"
        (mouseup)="isActive = false"
        (mouseleave)="isActive = false"
        (click)="activeModal.dismiss('Cross click')"
    >
        <img
        [src]="isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'"
        alt="close"
        />
    </button>
    </div>

    <div class="modal-body cdm-body">

    <!-- Environment -->
    <div class="cdm-field-group">
        <label class="cdm-label" for="cdm-env-local">Environment<span class="cdm-required">*</span></label>
        <div class="cdm-radio-group">
        <label class="cdm-radio-option" [class.selected]="form.environment === 'LOCAL'">
            <input type="radio" id="cdm-env-local" name="environment" value="LOCAL" [(ngModel)]="form.environment" />
            Local
        </label>
        <label class="cdm-radio-option" [class.selected]="form.environment === 'REMOTE'">
            <input type="radio" name="environment" value="REMOTE" [(ngModel)]="form.environment" />
            Remote
        </label>
        </div>
    </div>

    <!-- Device Name + Serial Number (LOCAL) / Device Name + Remote Environment (REMOTE) -->
    <div class="cdm-row">
        <div class="cdm-field-group">
        <label class="cdm-label" for="cdm-device-name">Device Name<span class="cdm-required">*</span></label>
        <input
            id="cdm-device-name"
            class="cdm-input"
            type="text"
            placeholder="Enter device name"
            [(ngModel)]="form.name"
        />
        </div>
        <div class="cdm-field-group" *ngIf="isLocal">
        <label class="cdm-label" for="cdm-serial-number">Serial Number<span class="cdm-required">*</span></label>
        <input
            id="cdm-serial-number"
            class="cdm-input"
            type="text"
            placeholder="Enter serial number"
            [(ngModel)]="form.serialNumber"
        />
        </div>
        <div class="cdm-field-group" *ngIf="!isLocal">
        <label class="cdm-label" for="cdm-remote-env">Remote Environment<span class="cdm-required">*</span></label>
        <select id="cdm-remote-env" class="cdm-select" [(ngModel)]="form.remoteEnvironment">
            <option value="" disabled>Select test environment</option>
            <option value="BROWSER_STACK">BrowserStack</option>
            <option value="LAMBDA_TEST">LambdaTest</option>
        </select>
        </div>
    </div>

    <!-- Remote Options accordion (REMOTE only) -->
    <ng-container *ngIf="!isLocal">
        <div class="cdm-remote-accordion">
        <div class="cdm-remote-accordion-header">
            <div class="d-flex align-items-center gap-2">
            <span class="cdm-remote-options-title">Remote Options ({{ remoteOptionsCount }})</span>
            <nz-switch [(ngModel)]="remoteOptionsEnabled" nzSize="small"></nz-switch>
            </div>
            <div class="d-flex align-items-center gap-3">
            <button
                *ngIf="remoteOptionsEnabled"
                type="button"
                class="cdm-add-option-btn"
                (click)="addRemoteOption(); remoteOptionsExpanded = true"
            >+ Add Remote Option(s)</button>
            <button
                type="button"
                class="cdm-accordion-toggle"
                (click)="remoteOptionsExpanded = !remoteOptionsExpanded"
            >
                <img
                [src]="remoteOptionsExpanded
                    ? 'assets/images/virtusa-icons/remove-outline.svg'
                    : 'assets/images/virtusa-icons/add-outline.svg'"
                alt="toggle"
                />
            </button>
            </div>
        </div>
        <div class="cdm-remote-accordion-body p-2 pt-0" *ngIf="remoteOptionsExpanded && remoteOptionsEnabled">
            <app-zorro-table
            tableId="cdm-remote-options"
            class="w-100"
            [columns]="remoteOptionsTableData.columns"
            [data]="remoteOptionsTableData.rows"
            (handleActions)="handleRemoteOptionsAction($event)"
            ></app-zorro-table>
        </div>
        </div>
    </ng-container>

    <!-- Platform selector -->
    <div class="cdm-field-group">
        <span class="cdm-label">Platform<span class="cdm-required">*</span></span>
        <div class="cdm-platform-group">
        <button
            type="button"
            class="cdm-platform-card"
            [class.active]="form.platform === 'ANDROID'"
            (click)="selectPlatform('ANDROID')"
        >
            <img src="assets/images/virtusa-icons/android.svg" alt="Android" class="cdm-platform-icon" />
            <span>Android</span>
        </button>
        <button
            type="button"
            class="cdm-platform-card"
            [class.active]="form.platform === 'IOS'"
            (click)="selectPlatform('IOS')"
        >
            <img src="assets/images/virtusa-icons/ios.svg" alt="iOS" class="cdm-platform-icon" />
            <span>iOS</span>
        </button>
        </div>
    </div>

    <!-- Platform Version -->
    <div class="cdm-field-group">
        <label class="cdm-label" for="cdm-platform-version">Platform Version<span class="cdm-required">*</span></label>
        <input
        id="cdm-platform-version"
        class="cdm-input"
        type="text"
        placeholder="Enter platform version"
        [(ngModel)]="form.platformVersion"
        />
    </div>

    <!-- Automation Port + Host (LOCAL only) -->
    <div class="cdm-row" *ngIf="isLocal">
        <div class="cdm-field-group">
        <label class="cdm-label" for="cdm-automation-port">Automation Port<span class="cdm-required">*</span></label>
        <input
            id="cdm-automation-port"
            class="cdm-input"
            type="text"
            placeholder="Enter automation port(0000)"
            [(ngModel)]="form.automationPort"
        />
        </div>
        <div class="cdm-field-group">
        <label class="cdm-label" for="cdm-host">Host<span class="cdm-required">*</span></label>
        <input
            id="cdm-host"
            class="cdm-input"
            type="text"
            placeholder="Enter host (0.0.0.0)"
            [(ngModel)]="form.host"
        />
        </div>
    </div>

    <!-- Username + Access Key (REMOTE only) -->
    <div class="cdm-row" *ngIf="!isLocal">
        <div class="cdm-field-group">
        <label class="cdm-label" for="cdm-username">Username<span class="cdm-required">*</span></label>
        <input id="cdm-username" class="cdm-input" type="text" placeholder="Enter username" [(ngModel)]="form.username" />
        </div>
        <div class="cdm-field-group">
        <label class="cdm-label" for="cdm-access-key">Access Key<span class="cdm-required">*</span></label>
        <input id="cdm-access-key" class="cdm-input" type="password" placeholder="Enter access key" [(ngModel)]="form.accessKey" />
        </div>
    </div>

    <!-- Execution Engine -->
    <div class="cdm-field-group">
        <span class="cdm-label">Execution Engine<span class="cdm-required">*</span></span>
        <app-dropdown-with-sections
          [config]="agentConfig"
          [fields]="agentSections"
          [selectedValue]="form.agentId"
          (onSelect)="onAgentSelect($event)"
        ></app-dropdown-with-sections>
    </div>

    <!-- Simulator checkbox (LOCAL only) -->
    <div class="cdm-checkbox-group" *ngIf="isLocal">
        <label class="cdm-checkbox-label">
        <input type="checkbox" [(ngModel)]="form.simulator" class="cdm-checkbox" />
        <span>This device is a simulator</span>
        </label>
    </div>

    </div>

    <div class="modal-footer cdm-footer">
    <button
        type="button"
        class="btn-accello-secondary"
        (click)="activeModal.dismiss('Cross click')"
    >
        Cancel
    </button>
    <button
        type="button"
        class="btn-accello-primary-light"
        [disabled]="!isFormValid || isLoading"
        (click)="submit()"
    >
        <span *ngIf="isLoading" class="cdm-spinner"></span>
        {{ isEditMode ? 'Update' : 'Create' }}
    </button>
    </div>

</div>